

declare const window: any;
const TRANSLATIONS = window["PRODUCT_SELECTOR_TRANSLATIONS"];

export const translate = (key: string) => {
    if (TRANSLATIONS[key]) {
        return TRANSLATIONS[key];
      }
      return key;
}